import React from 'react'
import './Hero.scss'

import heroImg from '../../../assets/images/neuroni-robotici-realizzati-con-l-immagine-del-generatore-ai-al-neon 1.png'
import Navbar from '../../Global/Navbar/Navbar'

const Hero = () => {
    return (
        <div className='hero-section-container '>
            {/* <Navbar /> */}
            <div className='hero-innerMain-container'>
                <div className='hero-left-container'>
                    <h1>Unleashing Unparalleled Efficiency and Innovation With<span> Relative Excess</span><span> Differentiation</span></h1>
                    <p>Our data illuminates the superheroic prowess of artificial intelligence</p>
                    <button className='theme-Btn-bg'><span>Get Started</span></button>
                </div>
                <div className='hero-right-container'>
                    <img src={heroImg} alt='' />
                </div>
            </div>
        </div>
    )
}

export default Hero